import "./aboutUs.css";
import { useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";

const Term = () => {
    
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
      
    return (
        <div className="about_us_main-container">
            <div className="about_us_topbar">
                <h2>Term</h2>
                <div className="about_us_searchbar">
                </div>
            </div>
            <hr />

            <div className="about_us_content">

                <div className="about_us_para">
                    <h3>Term’s and Conditions.</h3>
                </div>
                <div className="about_us_para">
                    <p>
                        The information displayed, revealed or carried by Oplas Tanzania Partnership has a copyright on all the content published at www.oplas.co.tz The information present on the website is precise, latest and correct to the best of our knowledge.
                    </p>
                </div>

                <div className="about_us_para">
                    <h4>General</h4>
                </div>
                <div className="about_us_para">
                    <p>
                        The information that is displayed on our website should not be used for any purpose that is unlawful or prohibited by the terms, conditions and policies. The content cannot be modified, published, transmitted, sold, or reproduced by any third party. Our website/Apps contains facts, views, opinions regarding our services and products but at the same time we don't represent or endorse the accuracy regarding the results obtained from the use of our information. Oplas Tanzania Partnership shall not be liable for any consequential, incidental damage or loss of profits or royalties arising out of any services provided by us. Nothing shall be considered as a substitute of personal investigation and the sound technical and business judgment of the reader.
                    </p>

                </div>

                <div className="about_us_para">
                    <h4>Privacy Policy</h4>
                </div>
                <div className="about_us_para">
                    <p>
                        We are a leading service provider in the e-Education and we do not share any information submitted by our clients to any third party. We own the sole right to discontinue any services or deny the access of any user if he fails to comply with the rules implemented by us. Web site content, projects or events, and the mentioned offers / prices are subjected to changes from time to time without any prior notice and the management decision regarding any kinds of dispute, if any, will be abiding.
                        By accessing the website, or App a user agrees to abide by all the copyright notices and restrictions attached to any content. The users should therefore periodically visit our website and review the current information of this posting.

                    </p>
                </div>

            </div>
        </div>
    );
};

export default Term;
